module.exports = __webpack_public_path__ + "static/fonts/iconfont.b9226bc5.woff";